<template lang="pug">
.container.--wide
  back-button

  table.draft-list.--table
    tr.draft-list__head
      th title
      th date

    tr.draft-list__item.--no-results(
      v-if="drafts.length === 0"
    ) 
      td(
        colspan="2"
      ) No Drafts
    tr.draft-list__item(
      v-for="draft in drafts"
    )
      td {{ draft.title }}
      td.updated-dt(
        :title="fullDate(draft.updatedAt)"
      ) {{ relativeDate(draft.updatedAt) }}
  
</template>

<script>
import { mapGetters } from 'vuex'
import DateHelpersMixin from '@/mixins/dateHelpers'
import BackButton from '@/components/back-button'
import PostList from '@/components/post/post-list'

export default {
  name: 'list-drafts',
  mixins: [DateHelpersMixin],
  components: {
    BackButton,
    PostList,
  },
  computed: {
    ...mapGetters(['drafts']),
  },
  methods: {
    fullDate(date) {
      return this.formatDate(date, 'PPPPpppp')
    },
    relativeDate(date) {
      return this.formatRelativeToNow(date)
    },
  },
}
</script>

<style lang="sass">
.draft-list
  margin-top: 4rem

  &.--table
    width: 100%
    border-collapse: collapse

    td
      border: 1px solid var(--base-color)

.draft-list__head
  text-transform: uppercase
  border-style: solid
  border-color: var(--base-color)
  border-width: 0 0 1px 0

.draft-list__item

  &.--no-results
    text-align: center
</style>
